/**
 * Hero Liquid Bubble Slider — Precision Touch/Drag Horizontal Slide Carousel
 * Celestial Saint Studio
 */

(function() {
  'use strict';

  function updateTopBannerOffset() {
    let topOffset = 0;
    const headerSection = document.querySelector('.hdt-section-header');
    if (headerSection) {
      const headerRect = headerSection.getBoundingClientRect();
      if (headerRect.top > 0) {
        topOffset = headerRect.top;
      }
    }

    const announcementEls = document.querySelectorAll('[class*="announcement"], [id*="announcement"], [data-essential-announcement-bar], .essential-announcement-bar');
    announcementEls.forEach(el => {
      if (el && el.offsetHeight > 0) {
        const style = window.getComputedStyle(el);
        if (style.display !== 'none' && style.position !== 'fixed' && style.position !== 'absolute') {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 10 && rect.height > topOffset) {
            topOffset = rect.height;
          }
        }
      }
    });

    const currentVal = document.documentElement.style.getPropertyValue('--top-banner-height');
    const newVal = `${Math.round(topOffset)}px`;
    if (currentVal !== newVal) {
      document.documentElement.style.setProperty('--top-banner-height', newVal);
    }
  }

  // Safe offset recalculation on resize and load without full body MutationObserver
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateTopBannerOffset, 100);
  }, { passive: true });
  window.addEventListener('load', updateTopBannerOffset, { passive: true });
  updateTopBannerOffset();

  function initHeroLiquidSliders() {
    updateTopBannerOffset();
    const sliders = document.querySelectorAll('[data-hero-liquid-slider]');
    sliders.forEach(slider => {
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      const viewport = slider.querySelector('[data-hero-liquid-viewport]');
      const track = slider.querySelector('[data-hero-liquid-track]');
      const slides = Array.from(slider.querySelectorAll('.hero-liquid-slide'));
      const dots = Array.from(slider.querySelectorAll('.hero-liquid-dot'));
      const prevBtn = slider.querySelector('.hero-liquid-nav-prev');
      const nextBtn = slider.querySelector('.hero-liquid-nav-next');
      
      if (!track || slides.length <= 1) return;

      let currentIndex = 0;
      let autoplayTimer = null;
      const isAutoplay = slider.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;

      // Gesture State
      let isDragging = false;
      let isTouchSwiping = false;
      let isTouchScrolling = null; // null = uncommitted, true = vertical page scroll, false = horizontal slider swipe
      let startPosX = 0;
      let startPosY = 0;
      let startTime = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID = 0;
      let hasMovedSignificantly = false;

      function getViewportWidth() {
        return (viewport && viewport.clientWidth) || slider.clientWidth || window.innerWidth;
      }

      function updateSlideClasses(index) {
        slides.forEach((slide, idx) => {
          if (idx === index) {
            slide.classList.add('is-active');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        dots.forEach((dot, idx) => {
          if (idx === index) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('is-active');
            dot.removeAttribute('aria-current');
          }
        });
      }

      function setSliderPosition() {
        track.style.transform = `translate3d(${currentTranslate.toFixed(2)}px, 0, 0)`;
      }

      function setPositionByIndex(animated = true) {
        const width = getViewportWidth();
        currentTranslate = -currentIndex * width;
        prevTranslate = currentTranslate;
        
        if (animated) {
          track.style.transition = 'transform 0.75s cubic-bezier(0.16, 1, 0.3, 1)';
        } else {
          track.style.transition = 'none';
        }

        setSliderPosition();
        updateSlideClasses(currentIndex);
      }

      function goToSlide(index, animated = true) {
        if (index < 0) {
          currentIndex = slides.length - 1;
        } else if (index >= slides.length) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }
        setPositionByIndex(animated);
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function prevSlide() {
        goToSlide(currentIndex - 1);
      }

      function startAutoplay() {
        if (!isAutoplay) return;
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      // =========================================================================
      // DEDICATED HIGH-PERFORMANCE MOBILE TOUCH HANDLING WITH AXIS LOCKING
      // =========================================================================
      function onTouchStart(e) {
        if (e.touches.length > 1) return;
        stopAutoplay();

        const touch = e.touches[0];
        startPosX = touch.clientX;
        startPosY = touch.clientY;
        startTime = Date.now();
        isTouchSwiping = false;
        isTouchScrolling = null;
        hasMovedSignificantly = false;

        track.style.transition = 'none';
      }

      function onTouchMove(e) {
        if (e.touches.length > 1) return;
        const touch = e.touches[0];
        const diffX = touch.clientX - startPosX;
        const diffY = touch.clientY - startPosY;

        // Determine scroll axis if not yet locked
        if (isTouchScrolling === null) {
          const absX = Math.abs(diffX);
          const absY = Math.abs(diffY);

          if (absX > 7 || absY > 7) {
            if (absY >= absX) {
              isTouchScrolling = true; // Vertical page scroll
            } else {
              isTouchScrolling = false; // Horizontal slider swipe
              isTouchSwiping = true;
              hasMovedSignificantly = true;
              viewport.classList.add('is-dragging');
            }
          }
        }

        // If user is swiping horizontally, lock page scroll and update track
        if (isTouchScrolling === false) {
          if (e.cancelable) e.preventDefault();
          currentTranslate = prevTranslate + diffX;
          setSliderPosition();
        }
      }

      function onTouchEnd(e) {
        if (isTouchScrolling === false && isTouchSwiping) {
          isTouchSwiping = false;
          viewport.classList.remove('is-dragging');

          const diffX = currentTranslate - prevTranslate;
          const timeElapsed = Date.now() - startTime;
          const velocity = Math.abs(diffX) / (timeElapsed || 1);
          const width = getViewportWidth();
          const threshold = Math.min(width * 0.15, 60);

          if (diffX < -threshold || (diffX < -20 && velocity > 0.35)) {
            nextSlide();
          } else if (diffX > threshold || (diffX > 20 && velocity > 0.35)) {
            prevSlide();
          } else {
            setPositionByIndex(true);
          }
        }

        isTouchScrolling = null;
        startAutoplay();

        setTimeout(() => {
          hasMovedSignificantly = false;
        }, 120);
      }

      // Touch Listeners
      viewport.addEventListener('touchstart', onTouchStart, { passive: true });
      viewport.addEventListener('touchmove', onTouchMove, { passive: false });
      viewport.addEventListener('touchend', onTouchEnd, { passive: true });
      viewport.addEventListener('touchcancel', onTouchEnd, { passive: true });

      // =========================================================================
      // DESKTOP MOUSE DRAG HANDLING
      // =========================================================================
      let isMouseDown = false;

      function onMouseDown(e) {
        if (e.button !== 0) return; // Left mouse only
        isMouseDown = true;
        isDragging = false;
        hasMovedSignificantly = false;
        startPosX = e.clientX;
        startTime = Date.now();
        stopAutoplay();
      }

      function onMouseMove(e) {
        if (!isMouseDown) return;
        const diffX = e.clientX - startPosX;

        if (!isDragging && Math.abs(diffX) > 6) {
          isDragging = true;
          hasMovedSignificantly = true;
          track.style.transition = 'none';
          viewport.classList.add('is-dragging');
        }

        if (isDragging) {
          currentTranslate = prevTranslate + diffX;
          setSliderPosition();
        }
      }

      function onMouseUp(e) {
        if (!isMouseDown) return;
        isMouseDown = false;

        if (isDragging) {
          isDragging = false;
          viewport.classList.remove('is-dragging');

          const diffX = currentTranslate - prevTranslate;
          const timeElapsed = Date.now() - startTime;
          const velocity = Math.abs(diffX) / (timeElapsed || 1);
          const width = getViewportWidth();
          const threshold = Math.min(width * 0.15, 70);

          if (diffX < -threshold || (diffX < -30 && velocity > 0.35)) {
            nextSlide();
          } else if (diffX > threshold || (diffX > 30 && velocity > 0.35)) {
            prevSlide();
          } else {
            setPositionByIndex(true);
          }
        }

        startAutoplay();
        setTimeout(() => {
          hasMovedSignificantly = false;
        }, 120);
      }

      viewport.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);

      // Prevent native HTML5 image/link ghost drag
      viewport.addEventListener('dragstart', (e) => e.preventDefault());

      // Intercept accidental link clicks only when a drag/swipe gesture occurred
      viewport.addEventListener('click', (e) => {
        if (hasMovedSignificantly) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Arrow Buttons
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          nextSlide();
          startAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          prevSlide();
          startAutoplay();
        });
      }

      // Dots
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          goToSlide(idx);
          startAutoplay();
        });
      });

      // Hover Pause (Desktop only)
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', () => {
          if (!isDragging && !isMouseDown) startAutoplay();
        });
      }

      // Viewport Resize Handler (Orientation & Responsive Changes)
      function handleViewportResize() {
        if (!isDragging && !isTouchSwiping && !isMouseDown) {
          setPositionByIndex(false);
        }
      }

      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => {
          handleViewportResize();
        });
        ro.observe(viewport);
      }

      window.addEventListener('resize', handleViewportResize, { passive: true });
      window.addEventListener('orientationchange', () => {
        setTimeout(handleViewportResize, 80);
      }, { passive: true });

      // Keyboard Navigation
      slider.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          prevSlide();
          startAutoplay();
        } else if (e.key === 'ArrowRight') {
          nextSlide();
          startAutoplay();
        }
      });

      // Shopify Theme Editor Integration
      document.addEventListener('shopify:block:select', (e) => {
        if (slider.contains(e.target)) {
          const slideElement = e.target.closest('.hero-liquid-slide');
          if (slideElement) {
            const index = slides.indexOf(slideElement);
            if (index !== -1) {
              goToSlide(index);
              stopAutoplay();
            }
          }
        }
      });

      // =========================================================================
      // DESKTOP-ONLY MAGNETIC REPULSION + HOVER ZOOM PHYSICS CONTROLLER
      // =========================================================================
      const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (isFinePointer) {
        const mediaBlocks = slider.querySelectorAll('.hero-liquid-media');
        mediaBlocks.forEach(media => {
          const imgWrap = media.querySelector('.hero-liquid-img-wrap');
          const blobWrap = media.querySelector('.hero-liquid-blob-wrap');
          if (!imgWrap) return;

          let isHovered = false;
          let rafId = null;

          let currentX = 0, currentY = 0, currentTiltX = 0, currentTiltY = 0, currentScale = 1;
          let targetX = 0, targetY = 0, targetTiltX = 0, targetTiltY = 0, targetScale = 1;

          let currentBlobX = 0, currentBlobY = 0, currentBlobScale = 1;
          let targetBlobX = 0, targetBlobY = 0, targetBlobScale = 1;

          const MAX_REPEL_X = 16;
          const MAX_REPEL_Y = 12;
          const MAX_TILT = 3;
          const HOVER_SCALE = 1.05;
          const BLOB_HOVER_SCALE = 1.04;
          const BLOB_MAX_REPEL_X = 8;
          const BLOB_MAX_REPEL_Y = 6;

          function updateMagneticPhysics() {
            const ease = 0.12;
            const blobEase = 0.08;

            currentX += (targetX - currentX) * ease;
            currentY += (targetY - currentY) * ease;
            currentTiltX += (targetTiltX - currentTiltX) * ease;
            currentTiltY += (targetTiltY - currentTiltY) * ease;
            currentScale += (targetScale - currentScale) * ease;

            currentBlobX += (targetBlobX - currentBlobX) * blobEase;
            currentBlobY += (targetBlobY - currentBlobY) * blobEase;
            currentBlobScale += (targetBlobScale - currentBlobScale) * blobEase;

            imgWrap.style.transform = `translate3d(${currentX.toFixed(2)}px, ${currentY.toFixed(2)}px, 0) scale(${currentScale.toFixed(4)}) rotateX(${currentTiltX.toFixed(2)}deg) rotateY(${currentTiltY.toFixed(2)}deg)`;

            if (blobWrap) {
              blobWrap.style.transform = `translate(calc(-50% + ${currentBlobX.toFixed(2)}px), calc(-50% + ${currentBlobY.toFixed(2)}px)) scale(${currentBlobScale.toFixed(4)})`;
            }

            const diff = Math.abs(targetX - currentX) +
                         Math.abs(targetY - currentY) +
                         Math.abs(targetTiltX - currentTiltX) +
                         Math.abs(targetTiltY - currentTiltY) +
                         Math.abs(targetScale - currentScale) +
                         Math.abs(targetBlobScale - currentBlobScale) +
                         Math.abs(targetBlobX - currentBlobX) +
                         Math.abs(targetBlobY - currentBlobY);

            if (isHovered || diff > 0.002) {
              rafId = requestAnimationFrame(updateMagneticPhysics);
            } else {
              imgWrap.style.transform = '';
              if (blobWrap) blobWrap.style.transform = '';
              rafId = null;
            }
          }

          function startPhysicsLoop() {
            if (!rafId) {
              rafId = requestAnimationFrame(updateMagneticPhysics);
            }
          }

          media.addEventListener('mouseenter', () => {
            if (isDragging || isMouseDown) return;
            isHovered = true;
            targetScale = HOVER_SCALE;
            targetBlobScale = BLOB_HOVER_SCALE;
            startPhysicsLoop();
          });

          media.addEventListener('mousemove', (e) => {
            if (isDragging || isMouseDown) return;
            const rect = media.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const normX = Math.max(-1, Math.min(1, (e.clientX - centerX) / (rect.width / 2)));
            const normY = Math.max(-1, Math.min(1, (e.clientY - centerY) / (rect.height / 2)));

            targetX = normX * MAX_REPEL_X;
            targetY = normY * MAX_REPEL_Y - 5;
            targetTiltX = -normY * MAX_TILT;
            targetTiltY = normX * MAX_TILT;
            targetScale = HOVER_SCALE;

            targetBlobX = normX * BLOB_MAX_REPEL_X;
            targetBlobY = normY * BLOB_MAX_REPEL_Y;
            targetBlobScale = BLOB_HOVER_SCALE;

            startPhysicsLoop();
          });

          media.addEventListener('mouseleave', () => {
            isHovered = false;
            targetX = 0;
            targetY = 0;
            targetTiltX = 0;
            targetTiltY = 0;
            targetScale = 1;

            targetBlobX = 0;
            targetBlobY = 0;
            targetBlobScale = 1;

            startPhysicsLoop();
          });
        });
      }

      // Live Scenery Preview Toolbar Controller
      const previewBar = slider.querySelector('[data-hero-preview-bar]');
      if (previewBar) {
        const sceneryButtons = previewBar.querySelectorAll('.hero-scenery-btn');
        const sceneryItems = slider.querySelectorAll('.hero-liquid-scenery-item');
        const opacitySlider = previewBar.querySelector('[data-scenery-opacity-slider]');
        const opacityVal = previewBar.querySelector('[data-scenery-opacity-val]');

        sceneryButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            const target = btn.dataset.sceneryTarget;
            sceneryButtons.forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');

            sceneryItems.forEach(item => {
              if (item.dataset.sceneryId === target) {
                item.classList.add('is-active');
              } else {
                item.classList.remove('is-active');
              }
            });
          });
        });

        if (opacitySlider && opacityVal) {
          opacitySlider.addEventListener('input', (e) => {
            const val = e.target.value;
            slider.style.setProperty('--scenery-opacity', (val / 100).toFixed(2));
            opacityVal.textContent = `${val}%`;
          });
        }
      }

      // Initial Setup
      setPositionByIndex(false);
      startAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroLiquidSliders);
  } else {
    initHeroLiquidSliders();
  }

  document.addEventListener('shopify:section:load', initHeroLiquidSliders);
})();
